import ConnectedCompanionSummary from './ConnectedCompanionSummary';

export default ConnectedCompanionSummary;
